import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaShieldAlt } from 'react-icons/fa';

const SECTIONS = [
  {
    title: 'Authentication via Google',
    body: (
      <>
        We use <strong>Google OAuth</strong> for authentication purposes only. When you log in to
        our service using your Google account, we verify your identity through Google without
        storing or collecting your account information, such as your email address or profile
        details.
      </>
    ),
  },
  {
    title: 'Purpose of Authentication',
    body: 'The authentication process is solely used to grant you secure access to the Pebsteel Portal. We do not collect, process, or share your Google account information for any other purpose.',
  },
  {
    title: 'No Data Storage',
    body: "Pebsteel Portal does not store any personal information retrieved through Google OAuth. All authentication details are processed securely via Google's OAuth services.",
  },
  {
    title: 'Data Protection',
    body: 'We prioritize your security and privacy. The authentication process uses encryption and follows industry standards to ensure your information is protected. We do not share your details with third parties.',
  },
  {
    title: 'Contact Us',
    body: (
      <>
        If you have any questions about this Privacy Policy or how we handle your information,
        please contact us at:{' '}
        <a
          href="mailto:portal@pebsteel.com.vn"
          className="tw-text-blue-600 hover:tw-underline tw-font-medium"
        >
          portal@pebsteel.com.vn
        </a>
      </>
    ),
  },
];

const PrivacyPolicy = () => (
  <div className="tw-max-w-3xl tw-mx-auto">
    {/* Header */}
    <div className="tw-bg-gradient-to-r tw-from-blue-600 tw-to-primary-600 tw-rounded-lg tw-shadow-sm tw-px-6 tw-py-8 tw-mb-4">
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
        <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-11 tw-h-11 tw-rounded tw-bg-white/15 tw-text-white">
          <FaShieldAlt size={22} />
        </span>
        <h1 className="tw-text-2xl tw-font-bold tw-text-white tw-mb-0">Privacy Policy</h1>
      </div>
      <p className="tw-text-sm tw-text-blue-50 tw-mb-0 tw-leading-relaxed">
        At PEB Portal, we are committed to protecting your privacy. This Privacy Policy explains how
        we use authentication services and handle any information you provide when accessing our
        platform.
      </p>
    </div>

    {/* Content card */}
    <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-solid tw-border-slate-100 tw-overflow-hidden">
      <div className="tw-px-6 tw-py-5 tw-divide-y tw-divide-slate-100">
        {SECTIONS.map((section, index) => (
          <section key={section.title} className="tw-py-4 first:tw-pt-0 last:tw-pb-0">
            <div className="tw-flex tw-items-start tw-gap-3">
              <span className="tw-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-xl tw-bg-blue-50 tw-text-blue-600 tw-text-sm tw-font-semibold">
                {index + 1}
              </span>
              <div>
                <h2 className="tw-text-base tw-font-semibold tw-text-slate-900 tw-mb-1">
                  {section.title}
                </h2>
                <p className="tw-text-sm tw-text-slate-600 tw-leading-relaxed tw-mb-0">
                  {section.body}
                </p>
              </div>
            </div>
          </section>
        ))}
      </div>

      <div className="tw-px-6 tw-py-4 tw-bg-slate-50 tw-border-t tw-border-solid tw-border-slate-100 tw-text-center">
        <Link
          to="/"
          className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-2 tw-rounded-md tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700 tw-text-sm tw-font-medium tw-cursor-pointer tw-border-0 tw-no-underline tw-transition-colors"
        >
          <FaHome /> Back to Home
        </Link>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;
